import React from "react";

interface SparklineProps {
  data: number[];
  width?: number;
  height?: number;
  color?: string;
}

const Sparkline: React.FC<SparklineProps> = ({
  data,
  width = 80,
  height = 32,
  color = "#6366f1",
}) => {
  if (data.length === 0) return null;
  if (!data.every((n) => Number.isFinite(n))) return null;

  if (data.length === 1) {
    const y = height / 2;
    return (
      <svg width={width} height={height} className="cl-metric-card__sparkline">
        <line
          x1={2}
          y1={y}
          x2={width - 2}
          y2={y}
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <circle cx={width / 2} cy={y} r={2.5} fill={color} />
      </svg>
    );
  }

  const max = Math.max(...data);
  const min = Math.min(...data);
  const range = max - min || 1;
  const padding = 2;
  const step = (width - padding * 2) / (data.length - 1);

  const points = data
    .map((v, i) => {
      const x = padding + i * step;
      const y = height - padding - ((v - min) / range) * (height - padding * 2);
      return `${x},${y}`;
    })
    .join(" ");

  const fillPoints = `${padding},${height - padding} ${points} ${width - padding},${height - padding}`;

  return (
    <svg width={width} height={height} className="cl-metric-card__sparkline">
      <polyline fill="none" stroke={color} strokeWidth="1.5" points={points} />
      <polygon fill={color} fillOpacity="0.1" points={fillPoints} />
    </svg>
  );
};

Sparkline.displayName = "Sparkline";
export default Sparkline;
